<template>
    <div v-if="show" class="col-12">
        <div class="form-group row m-b-sm">
            <div class="col max-w-20"></div>
            <div class="col p-r-5"></div>
            <div class="col text-right max-w-160 p-l-5 p-r-5"></div>
            <div class="col text-right max-w-160 p-l-5 p-r-5"></div>
            <div class="col text-right max-w-200 p-l-5 p-r-5"></div>

            <div class="col text-right max-w-120 p-l-5 p-r-5">
                <label class="label-greyish">{{ __('roundings') }}</label>
                <input :value="roundingsNet | money" class="form-control text-right" disabled type="text">
            </div>
            
            <div class="col text-right max-w-110 p-l-5 p-r-5"></div>
            <div class="max-w-120 col text-right p-l-5 p-r-5">
                <label class="label-greyish">{{ __('roundings') }}</label>
                <input :value="roundingsVat | money" class="form-control text-right" disabled type="text">
            </div>

            <div class="max-w-120 col text-right  p-l-5 p-r-5">
                <label class="label-greyish">{{ __('roundings') }}</label>
                <input :value="roundingsGross | money" class="form-control text-right" disabled type="text">
            </div>

            <div style="width: 45px"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RoundingRow",
    props: {
        roundings: {
            type: Object,
            required: true,
        },
    },
    methods: {
        notZero(number) {
            number = parseFloat(number.toFixed(2));
            return number > 0 || number < 0;
        },
    },
    computed: {
        show() {
            return this.notZero(this.roundingsNet) || this.notZero(this.roundingsVat) || this.notZero(this.roundingsGross);
        },
        roundingsNet() {
            return this.roundings.net;
        },
        roundingsVat() {
            return this.roundings.vat;
        },
        roundingsGross() {
            return this.roundings.gross;
        },
    },
};
</script>
